import "../../../chunk-D57E6H3M.mjs";

// src/components/composite/LiveAnnouncer/LiveAnnouncer.tsx
import { jsx } from "react/jsx-runtime";
function LiveRegion({ message }) {
  return /* @__PURE__ */ jsx("div", { role: "status", "aria-live": "polite", "aria-atomic": "true", className: "buyscout-live-region", children: message });
}
LiveRegion.displayName = "LiveRegion";
export {
  LiveRegion
};
//# sourceMappingURL=LiveAnnouncer.mjs.map